module.exports = __webpack_public_path__ + "static/media/nav-appointments.134af5bb.svg";